<template>
  <div class="elive-pagecon">
    <div class="elive-wrap" v-loading="dataLoading">
      <div class="topbanner"><img :src="`https://imgs.sialchina.cn/eventlive/images/topbanner.jpg?v=${new Date().getTime()}`" alt=""></div>
      <!-- <div class="live-box">
        <div class="live-titbox">
            <h2 class="tit">Summit <span>Tickets</span></h2>
            <div class="right">
                <router-link :to="`${$t('baseurl')}/forumticket`"><el-button type="primary">More</el-button> </router-link>
            </div>
        </div>

        <el-row :gutter="24" class="forum-list">
            <el-col :md="8" :sm="12" v-for="item in onsiteList" :key="item.id" class="li">
                <div class="imgbox"><img :src="item.image ? item.image : defaultImg" :alt="item.title"></div>
                <div class="txtbox">
                    <p class="tit">{{item.title_en}}</p>
                    <div class="info">{{item.brief_en}}</div>
                    <p class="date"><el-icon><Clock /></el-icon> {{setFormatTime(item.date_start_en, item.date_end_en, "Y-M-D h:m")}} <br><el-icon><Location /></el-icon> {{item.location_en}}</p>

                    <router-link :to="`${$t('baseurl')}/forumticket/${item.id}`" v-if="$store.getters.isLogin"><el-button type="warning" size="large"> {{ item.button_en || 'Purchase Ticket' }}</el-button></router-link>
                    <el-button v-else type="warning" size="large" @click="toLogin"> {{ item.button_en || 'Purchase Ticket' }}</el-button>
                    
                </div>
            </el-col>
        </el-row>
      </div> -->

      <div class="live-box">
        <div class="live-titbox">
            <h2 class="tit">Live <span>Streaming</span></h2>
            <div class="right">
                <router-link :to="`${$t('baseurl')}/eventlive/livelist`"><el-button type="primary">More</el-button> </router-link>
            </div>
        </div>

        <el-row :gutter="24" class="livelist">
            <el-col :md="8" :sm="12" v-for="item in liveList" :key="item.id" class="li">
              <div class="imgbox"><img :src="item.image_en ? item.image_en : defaultImg" :alt="item.name_en"></div>
              <div class="txtbox">
                <div class="info">
                  <p class="tit">{{item.name_en}}</p>
                  <p class="p date"><i class="iconfont icon-time-circle-fill"></i> Time: <span>{{setFormatTime(item.start_time_en, item.end_time_en, "Y-M-D h:m")}}</span></p>
                  <div class="p type">
                      <p class="fl"><i class="iconfont icon-yijicaidan"></i> Category: {{item.cate_name_en}}, {{item.cate2_name_en}}</p>
                      <p class="fr"><el-text type="warning"><i class="iconfont icon-fire"></i></el-text> {{item.views}}</p>
                  </div>
                  <a :href="item.introduce_en" target="_blank" class="fcdeep">Introduction <el-icon><DArrowRight /></el-icon></a>
                </div>
                <div class="btnbox">
                    <router-link :to="`${$t('baseurl')}/eventlive/livelist/info/${item.id}`" class="a" v-if="$store.getters.isLogin"><el-button type="warning" size="large"> 
                      {{ item.cid_2 == 10 ? 'Free Live Streaming' : (item.is_buy == 0 ? 'Live Streaming' : 'Watch video now')}}</el-button>
                    </router-link>
                    <el-button v-else type="warning" size="large" class="a" @click="toLogin"> {{ item.cid_2 == 10 ? 'Free Live Streaming' : (item.is_buy == 0 ? 'Live Streaming' : 'Watch video now')}}</el-button>
                    
                    <el-button type="primary" size="large"  class="a" @click="doReservationLive(item.id)" v-if="item.is_reservation == 0"> Subscribe now</el-button>
                    <el-button type="primary" plain size="large"  class="a" v-else> Subscribed</el-button>
                </div>
              </div>
            </el-col>
        </el-row>
      </div>

      <div class="live-box">
        <div class="live-titbox">
            <h2 class="tit">Highlight <span>Speech</span></h2>
            <div class="right">
                <router-link :to="`${$t('baseurl')}/eventlive/master`"><el-button type="primary">More</el-button> </router-link>
            </div>
        </div>
        <el-row :gutter="24" class="master-list">
          <el-col :lg="6" :sm="8" :xs="12" v-for="item in masterList" :key="item.id" class="li">
            <div class="head"><div class="img"><img :src="item.image_en ? item.image_en : defaultImg2" :alt="item.name_en"></div></div>
            <div class="txtbox">
                <p class="p1">{{item.name_en}}</p>
                <p class="p2">{{item.job_title_en}}</p>

                <router-link :to="`${$t('baseurl')}/eventlive/livelist/info/${item.id}`" class="a" v-if="$store.getters.isLogin"><el-button :type="(item.cid_2 == 10 || item.is_buy != 0 ) ? 'primary' : 'warning'" size="large"> 
                  {{ item.cid_2 == 10 ? 'Free Live Streaming' : (item.is_buy == 0 ? 'Live Streaming' : 'Watch video now')}}</el-button>
                </router-link>
                <el-button v-else :type="(item.cid_2 == 10 || item.is_buy != 0 ) ? 'primary' : 'warning'" size="large" class="a" @click="toLogin"> {{ item.cid_2 == 10 ? 'Free Live Streaming' : (item.is_buy == 0 ? 'Live Streaming' : 'Watch video now')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
</div>
</template>

<script>
import { reactive, toRefs } from "vue";
import { useStore } from "vuex";

import { getEventCollection, reservationLive } from "@/api/eventlive";
import {  rangeFormatTime } from "@/utils/common"
import showMsg from "@/utils/message";
import Cookies from "js-cookie";

export default {
  setup(){
    const state = reactive({
      
      dataLoading: true,
      defaultImg: require("@/assets/images/default.jpg"),
      defaultImg2: require("@/assets/images/touxn.png"),
      onsiteList: [],
      liveList: [],
      masterList: []
    })

    getData();
    function getData() { 
      getEventCollection({app_lang: "en",}).then((res)=>{
        const { data }= res;
        state.onsiteList = data.event_list;
        state.liveList = data.live_list;
        state.masterList = data.live_list2;
        state.dataLoading = false;
      }).catch((err)=>{
        showMsg.error(err.msg);
        state.dataLoading = false;
      })
    }

    const store = useStore();

    const toLogin = ()=>{
      store.commit("eventlive/SET_EVENTLIVE_SHOW_LOGIN",true);
    }
    // 订阅直播
    const doReservationLive = (id)=>{
      reservationLive({live_id: id}).then(()=>{
        showMsg.success("Subscribe successfully");
        getData();
      }).catch((err)=>{
        showMsg.error(err.msg);
      })
    }

    // 日期格式
    const setFormatTime = (start_time, end_time, format)=>{
      var start = new Date(start_time)/1000;
      var end = new Date(end_time)/1000;
      return rangeFormatTime(start, end, format)
    }

    return {
      ...toRefs(state),
      toLogin,
      doReservationLive,
      setFormatTime
    }
  }
}
</script>

<style lang="less" scoped>
.live-box {
  margin: 35px 0;
}

</style>